export default {
  row: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    margin: 5,
    padding: 5,
  },
  column: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  body: {
    margin: 10,
  },
  paper: {
    padding: 10,
    margin: 3,
  },
  header: {
    textWeight: 'bold',
  },
  format: {
    // flex: 1,
    // padding: 10,
  },
  layoutValue: {
    textAlign: 'right',
  },
  exceedingLimits: {
    display: 'flex',
    alignItems: 'center',
    margin: 5,
    backgroundColor: 'red',
    padding: 10,
    color: 'white',
  },
  warningIcon: {
    color: 'white',
    paddingRight: 10,
  },
};



// WEBPACK FOOTER //
// ./src/components/GenerateLabelsDialog/styles.js